<div class="resend-confirm-dialog">
  <div class="resend-confirm-dialog__header">Confirm Resend</div>
  <div class="resend-confirm-dialog__content">
    <p>
      You are about to resend order <strong>{{ data.externalOrderNumber }}</strong> (Dispense Order ID: <strong>{{ data.dispenseOrderId }}</strong>) to Columbus.
    </p>
    <p>
      This action will trigger a new dispatch of the prescription. Please make sure the order is eligible for resend before proceeding.
    </p>
    <div class="resend-confirm-dialog__actions">
      <button class="btn btn-grey" (click)="cancel()">Cancel</button>
      <button class="btn btn-success" (click)="confirm()">Confirm</button>
    </div>
  </div>
</div>
